/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./launch.vue?vue&type=template&id=2d89c0a1"
import script from "./launch.vue?vue&type=script&lang=js"
export * from "./launch.vue?vue&type=script&lang=js"
import style0 from "./launch.vue?vue&type=style&index=0&id=2d89c0a1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports